// removed by extract-text-webpack-plugin
module.exports = {"base":"ClanLeavingLayout_base--19_zI","closeButton":"ClanLeavingLayout_closeButton--1BrZx","main":"ClanLeavingLayout_main--35C6D","title":"ClanLeavingLayout_title--3GQGX","warning":"ClanLeavingLayout_warning--2UAjQ","warningText":"ClanLeavingLayout_warningText--20NNN","buttons":"ClanLeavingLayout_buttons--3GZQP","button":"ClanLeavingLayout_button--XFI7D","button__leaving":"ClanLeavingLayout_button__leaving--3vXP8","buttonLeaving":"ClanLeavingLayout_button__leaving--3vXP8"};


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLeaving/components/ClanLeavingLayout/ClanLeavingLayout.scss
// module id = 2416
// module chunks = 11